import type { ReactNode } from "react";
import { Tooltip } from "@mui/material";
import { addHours, format } from "date-fns";
import { capitalize } from "es-toolkit/string";
import type { Task } from "src/queries/tasks/tasks.types";
import { useGlobalLocalContext } from "src/storage/localStorage";
import { secondsToHumanReadable } from "src/utils/time";

interface TaskSelectorDefaultRenderOptionTooltipProps {
  children: ReactNode;
  option: Task;
  startTime: Date;
  endTime: Date | undefined;
  isRetry?: boolean;
}

const TaskSelectorDefaultRenderOptionTooltip = ({
  children,
  option,
  startTime,
  endTime,
  isRetry,
}: TaskSelectorDefaultRenderOptionTooltipProps) => {
  const tz = useGlobalLocalContext((state) => state.tz);
  return (
    <Tooltip
      arrow
      placement="left"
      disableInteractive
      title={
        <div className="grid grid-cols-[auto_1fr] gap-x-4">
          {isRetry && (
            <>
              <strong className="mb-2">Retry task run</strong>
              <div />
            </>
          )}

          <strong>Status:</strong>
          <span>{capitalize(option.status)}</span>
          <strong>Start:</strong>
          <span>{format(addHours(startTime, tz), "PPpp")}</span>
          {endTime && (
            <>
              <strong>End:</strong>
              <span>{format(addHours(endTime, tz), "PPpp")}</span>
              <strong>Duration:</strong>
              <span>{secondsToHumanReadable(option.duration)}</span>
            </>
          )}
        </div>
      }
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default TaskSelectorDefaultRenderOptionTooltip;
